module.exports = __webpack_public_path__ + "static/fantasticfries-bb0de744a3ab58db97ad3060819ac342.png";